(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "styled-components"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("styled-components"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.styledComponents);
    global.index = mod.exports;
  }
})(this, function (_exports, _react, _styledComponents) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.StickyTable = StickyTable;
  _exports.Cell = _exports.Row = _exports.Table = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _templateObject4() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: auto;\n  height: 100%;\n  box-sizing: border-box;\n\n\n  & ", ":not(:last-child) ", " {\n    border-bottom: ", ";\n  }\n\n  & ", ":nth-child(", ") ", " {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0px;\n    z-index: ", ";\n  }\n  & ", ":nth-last-child(-n+", ") ", " {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0px;\n    z-index: ", ";\n    border-top: ", ";\n  }\n  & ", " ", ":nth-child(-n+", ") {\n    position: -webkit-sticky;\n    position: sticky;\n    left: 0px;\n    z-index: ", ";\n    border-right: ", ";\n  }\n  & ", " ", ":nth-last-child(-n+", ") {\n    position: -webkit-sticky;\n    position: sticky;\n    right: 0px;\n    z-index: ", ";\n    border-left: ", ";\n  }\n\n  & ", ":nth-child(-n+", ") ", ":nth-child(-n+", ") {\n    z-index: ", ";\n  }\n  & ", ":nth-child(-n+", ") ", ":nth-last-child(-n+", ") {\n    z-index: ", ";\n  }\n  & ", ":nth-last-child(-n+", ") ", ":nth-child(-n+", ") {\n    z-index: ", ";\n  }\n  & ", ":nth-last-child(-n+", ") ", ":nth-last-child(-n+", ") {\n    z-index: ", ";\n  }\n"]);
    _templateObject4 = function _templateObject4() {
      return data;
    };
    return data;
  }
  function _templateObject3() {
    var data = _taggedTemplateLiteral(["\n  display: table-row;\n"]);
    _templateObject3 = function _templateObject3() {
      return data;
    };
    return data;
  }
  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  box-sizing: border-box;\n  padding: 0.5rem 0.75rem;\n  background-color: #fff;\n"]);
    _templateObject2 = function _templateObject2() {
      return data;
    };
    return data;
  }
  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  display: table;\n  box-sizing: border-box;\n"]);
    _templateObject = function _templateObject() {
      return data;
    };
    return data;
  }
  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }
  var getBorder = function getBorder(props) {
    return "".concat(props.borderWidth === undefined ? '2px' : props.borderWidth || '0px', " solid ").concat(props.borderColor || '#e5e5e5');
  };
  var Table = (0, _styledComponents["default"])('div').attrs({
    className: 'sticky-table-table'
  })(_templateObject());
  _exports.Table = Table;
  Table.displayName = 'Table';
  var Cell = (0, _styledComponents["default"])('div').attrs({
    className: 'sticky-table-cell'
  })(_templateObject2());
  _exports.Cell = Cell;
  Cell.displayName = 'Cell';
  var Row = (0, _styledComponents["default"])('div').attrs({
    className: 'sticky-table-row'
  })(_templateObject3());
  _exports.Row = Row;
  Row.displayName = 'Row';
  var Wrapper = (0, _styledComponents["default"])('div').attrs({
    className: 'sticky-table'
  })(_templateObject4(), Row, Cell, getBorder, Row, function (props) {
    return "-n+".concat(props.stickyHeaderCount);
  }, Cell, function (props) {
    return props.headerZ || 2;
  }, Row, function (props) {
    return props.stickyFooterCount;
  }, Cell, function (props) {
    return props.footerZ || 2;
  }, getBorder, Row, Cell, function (props) {
    return props.leftStickyColumnCount;
  }, function (props) {
    return props.leftColumnZ || 2;
  }, getBorder, Row, Cell, function (props) {
    return props.rightStickyColumnCount;
  }, function (props) {
    return props.rightColumnZ || 2;
  }, getBorder, Row, function (props) {
    return props.stickyHeaderCount;
  }, Cell, function (props) {
    return props.leftStickyColumnCount;
  }, function (props) {
    return Math.max(props.headerZ || 2, props.leftColumnZ || 2) + 1;
  }, Row, function (props) {
    return props.stickyHeaderCount;
  }, Cell, function (props) {
    return props.rightStickyColumnCount;
  }, function (props) {
    return Math.max(props.headerZ || 2, props.rightColumnZ || 2) + 1;
  }, Row, function (props) {
    return props.stickyFooterCount;
  }, Cell, function (props) {
    return props.leftStickyColumnCount;
  }, function (props) {
    return Math.max(props.footerZ || 2, props.leftColumnZ || 2) + 1;
  }, Row, function (props) {
    return props.stickyFooterCount;
  }, Cell, function (props) {
    return props.rightStickyColumnCount;
  }, function (props) {
    return Math.max(props.footerZ || 2, props.rightColumnZ || 2) + 1;
  });
  Wrapper.displayName = 'Wrapper';
  function StickyTable(_ref) {
    var _ref$leftStickyColumn = _ref.leftStickyColumnCount,
      leftStickyColumnCount = _ref$leftStickyColumn === void 0 ? 1 : _ref$leftStickyColumn,
      _ref$stickyHeaderCoun = _ref.stickyHeaderCount,
      stickyHeaderCount = _ref$stickyHeaderCoun === void 0 ? 1 : _ref$stickyHeaderCoun,
      wrapperRef = _ref.wrapperRef,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["leftStickyColumnCount", "stickyHeaderCount", "wrapperRef", "children"]);
    return _react["default"].createElement(Wrapper, _extends({
      ref: wrapperRef,
      leftStickyColumnCount: leftStickyColumnCount,
      stickyHeaderCount: stickyHeaderCount
    }, restProps), _react["default"].createElement(Table, null, children));
  }
});